import styled from "styled-components";
export const Wrapper = styled.div `
  position: relative;
  background-color: ${({ theme }) => theme.colors.grey03};
  height: 2.5rem;
  width: 100%;
  z-index: 2;

  & button {
    padding: 0.625rem 0.25rem;
    font-family: ${({ theme }) => theme.fontTokens.defaultFont};
  }
`;
export const ContentWrapper = styled.div `
  display: flex;
  justify-content: space-between;
`;
export const RightWrapper = styled.div `
  display: flex;
  flex: 1;
  a {
    margin-left: 1rem;
    cursor: pointer;
    &:last-child {
      margin-right: 1.5rem;
    }
  }
`;
export const LeftWrapper = styled.div `
  display: flex;
  margin-left: 1.5rem;

  svg {
    fill: ${({ theme }) => theme.colors.grey15};
  }
`;
export const ButtonWrapper = styled.div `
  margin-left: 1.5rem;

  & button {
    padding: 0.5625rem 1.5rem;

    &:active {
      color: ${({ theme }) => theme.colors.black};
    }
  }
`;
export const EditAreaPlaceholder = styled.div `
  min-width: 2rem;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  border: 3px dashed #999;
  color: #999;
`;
